import React from 'react'
import { Grid, TextField } from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'

const escolaridadeOptions = [
  'Sem escolaridade',
  'Educação Infantil',
  'Ensino Fundamental Incompleto',
  'Ensino Fundamental Completo',
  'Ensino Médio Incompleto',
  'Ensino Médio Completo',
  'Ensino Superior Incompleto',
  'Ensino Superior Completo',
]

export const FormOutrosDados = (props) => {
  const { formPericiando, classes } = props

  return (
    <Grid container spacing={2} className={classes.fieldGroup}>
      {/* Ocupação */}
      <Grid item md={7} sm={7} xs={12}>
        <TextField
          error={formPericiando.hasError('ocupacao')}
          fullWidth
          helperText={formPericiando.hasError('ocupacao') ? formPericiando.formState.errors.ocupacao[0] : null}
          label="OCUPAÇÃO"
          name="ocupacao"
          onChange={formPericiando.handleChange}
          value={formPericiando.formState.values.ocupacao || ''}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      {/* Escolaridade */}
      <Grid item md={7} sm={7} xs={12}>
        <AutocompleteNative
          name="escolaridade"
          fullWidth
          value={formPericiando.formState.values.escolaridade || null}
          noOptionsText="Sem informações"
          options={escolaridadeOptions}
          getOptionSelected={(option, value) => option === value}
          onChange={(event, newValue) => {
            formPericiando.handleChangeNewValueByNameProperty(event, newValue, 'escolaridade')
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="ESCOLARIDADE"
              placeholder="Selecionar..."
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
        />
      </Grid>
    </Grid>
  )
}
